import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Grid } from '@material-ui/core'
import axios from 'axios'
import { API_HOST } from '../../../consts'

const CardLogin = () => {
  const [login, setLogin] = useState({ username: '', password: '' })

  const StyleTitle = {
    fontFamily: 'Public Sans',
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: '27px',
    color: '#262930'
  }

  const StyleContainer = {
    padding: '22px 41px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '5.622431755065918px 5.622431755065918px 22.489727020263672px 0px #0000004D',
    borderRadius: '4.5px',
    width: '100%',

  }

  const StyleContainerInput = {
    marginBottom: '27px'
  }

  const StyleInput = {
    padding: '18px 15px',
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 400,
    border: '2.25px solid #C0C0C0',
    borderRadius: '4.5px',
    width: '100%'
  }

  const StyleButton = {
    padding: '8px 125px',
    color: '#fff',
    fontFamily: 'Public Sans',
    fontSize: '16px',
    fontWeight: 700,
    borderRadius: "24px",
    border: 'none',
    width: '100%',
    backgroundColor: '#0047B6',
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      enter();
    }
  }

  const handleInput = (name, value) => {
    setLogin((prevLogin) => ({
      ...prevLogin,
      [name]: value,
    }))
  }

  const enter = async () => {
    try {
      const response = await axios.post(`${API_HOST}/login`, login);
      localStorage.setItem('token', response.data.token);
      window.open('/portal-educat', '_self');
      toast.success("Login realizado com sucesso.")
    } catch (error) {
      toast.error("Impossível fazer login com as credenciais fornecidas.")
    }
  }

  return (
    <Grid container justifyContent='center' width="100%">
      <Grid style={StyleContainer} item direction='column'>
        <Grid item xs={12} style={StyleTitle}>Faça seu login</Grid>
        <Grid item xs={12} style={StyleContainerInput}>
          <input style={StyleInput} onChange={(e) => {
            handleInput('username', e.target.value);
          }} type="text" placeholder='Usuário/E-mail' />
        </Grid>
        <Grid item xs={12} style={StyleContainerInput}><input style={StyleInput} onChange={(e) => {
          handleInput('password', e.target.value);
         }} type="password" placeholder='Código de acesso' onKeyPress={handleKeyPress} /></Grid>
        <Grid item xs={12}><button onClick={() => enter()} style={StyleButton}>Acessar</button></Grid>
      </Grid>
    </Grid>
  )
}

export default CardLogin
